/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import customerFieldsetTemplate from './customer-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function CustomerDirective($compile, $templateCache, $log, $translate, types, toast, customerSubscriptionService) {
    var linker = function (scope, element) {
        var template = $templateCache.get(customerFieldsetTemplate);

        element.html(template);
        scope.types = types;

        scope.onCustomerIdCopied = function() {
            toast.showSuccess(
                $translate.instant('customer.id-copied-message'),
                750,
                angular.element(element).closest(".toast-parent"),
                'bottom left'
            );
        };

        scope.$watch('customer.customerSubscriptionId', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    customerSubscriptionService.getCustomerSubscription(scope.customer.customerSubscriptionId.id).then(
                        (customerSubscription) => scope.customerSubscription = customerSubscription
                    );
                } else {
                    scope.customerSubscription = null;
                }
            }
        });

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (newVal && !angular.equals(newVal, prevVal)) {
                scope.selectedTab = 0;
            }
        });

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            customer: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/customer/customer.directive.js